import { SaveableSettingsProvider } from "../saveable-settings-provider";
import { getItemByField } from "../../../../../../web-graphics";

export class PlotSaveableSettingsProvider extends SaveableSettingsProvider {
  constructor() {
    super();
  }

  createSaveableSettings(settings) {
    if (settings === undefined || settings.plotContent === undefined) {
      return {};
    }
    const signalsSaveableSettings = {};
    const dataSources = [];

    const saveableSettings = {
      plotContent: {
        central: [
          {
            type: "graphic",
            name: "signals",
            place: "central",
            settings: signalsSaveableSettings
          }
        ]
      },
      dataSources: dataSources
    };

    let usedChannelScaleXIndex = false;
    let usedChannelScaleYIndex = false;
    // from every channel settings
    for (let sourceIndex = 0; sourceIndex < settings.dataSources.length; sourceIndex++) {
      const dataSourceSettings = settings.dataSources[sourceIndex];
      const savedChannels = [];
      const savedDataSourceSettings = {
        id: dataSourceSettings.id,
        channels: savedChannels
      };

      for (let channelIndex = 0; channelIndex < dataSourceSettings.channels.length; channelIndex++) {
        const channelSettings = dataSourceSettings.channels[channelIndex];
        const savedChannelSettings = {
          id: channelSettings.id
        };
        if (channelSettings.filters !== undefined) {
          savedChannelSettings.filters = [...channelSettings.filters];
        }
        savedChannelSettings.scaleX = {};
        savedChannelSettings.scaleY = {};

        if (channelSettings.scaleX !== undefined) {
          if (channelSettings.scaleX.index !== undefined && !(channelSettings.scaleX._isUsedCommonIndex ?? false)) {
            savedChannelSettings.scaleX.index = channelSettings.scaleX.index;
            usedChannelScaleXIndex = true;
          }
          if (channelSettings.scaleX.values !== undefined && !(channelSettings.scaleX._isUsedCommonValues ?? false)) {
            savedChannelSettings.scaleX.values = [...channelSettings.scaleX.values];
          }
        }
        if (channelSettings.scaleY !== undefined) {
          if (channelSettings.scaleY.index !== undefined && !(channelSettings.scaleY._isUsedCommonIndex ?? false)) {
            savedChannelSettings.scaleY.index = channelSettings.scaleY.index;
            usedChannelScaleYIndex = true;
          }
          if (channelSettings.scaleY.values !== undefined && !(channelSettings.scaleY._isUsedCommonValues ?? false)) {
            savedChannelSettings.scaleY.values = [...channelSettings.scaleY.values];
          }
        }
        savedChannels.push(savedChannelSettings);
      }
      dataSources.push(savedDataSourceSettings);
    }

    // from plotContent "signals"
    let signalsSettings = getItemByField("name", "signals", settings.plotContent.central);
    if (signalsSettings?.settings !== undefined) {
      signalsSettings = signalsSettings.settings;
      signalsSaveableSettings.selectedFilters = signalsSettings.selectedFilters ?? signalsSettings.defaultFilters ?? [];
      if (signalsSettings.scaleX !== undefined) {
        const scaleXSettings = {};
        signalsSaveableSettings.scaleX = scaleXSettings;
        if (!usedChannelScaleXIndex && signalsSettings.scaleX.currIndex !== undefined) {
          scaleXSettings.defaultIndex = signalsSettings.scaleX.currIndex;
        } else {
          scaleXSettings.defaultIndex = signalsSettings.scaleX.defaultIndex;
        }
      }
      if (signalsSettings.scaleY !== undefined) {
        const scaleYSettings = {};
        signalsSaveableSettings.scaleY = scaleYSettings;
        if (!usedChannelScaleYIndex && signalsSettings.scaleY.currIndex !== undefined) {
          scaleYSettings.defaultIndex = signalsSettings.scaleY.currIndex;
        } else {
          scaleYSettings.defaultIndex = signalsSettings.scaleY.defaultIndex;
        }
      }
    }

    return saveableSettings;
  }

  applySaveableSettings(settings, saveableSettings) {
    if (settings === undefined || settings.plotContent === undefined) {
      return;
    }

    // from every channel settings
    if (saveableSettings.dataSources !== undefined) {
      for (let sourceIndex = 0; sourceIndex < saveableSettings.dataSources.length; sourceIndex++) {
        const savedDataSourceSettings = saveableSettings.dataSources[sourceIndex];
        const dataSourceSettings = getItemByField("id_dataSource", savedDataSourceSettings.id, settings.dataSources);
        if (dataSourceSettings !== undefined) {
          for (let channelIndex = 0; channelIndex < savedDataSourceSettings.channels.length; channelIndex++) {
            const savedChannelSettings = savedDataSourceSettings.channels[channelIndex];
            const channelSettings = getItemByField("id_channel", savedChannelSettings.id, dataSourceSettings.channels);
            if (channelSettings !== undefined) {
              if (savedChannelSettings.filters !== undefined) {
                channelSettings.filters = [...savedChannelSettings.filters];
              }
              if (savedChannelSettings.scaleX?.index !== undefined) {
                if (channelSettings.scaleX === undefined) {
                  channelSettings.scaleX = {};
                }
                channelSettings.scaleX.index = savedChannelSettings.scaleX.index;
              }
              if (savedChannelSettings.scaleY?.index !== undefined) {
                if (channelSettings.scaleY === undefined) {
                  channelSettings.scaleY = {};
                }
                channelSettings.scaleY.index = savedChannelSettings.scaleY.index;
              }
            }
          }
        }
      }
    }

    // from plotContent "signals"
    let signalsSettings = getItemByField("name", "signals", settings.plotContent.central);
    let signalsSaveableSettings = getItemByField("name", "signals", saveableSettings.plotContent.central);
    if (signalsSettings?.settings === undefined || signalsSaveableSettings?.settings === undefined) {
      return;
    }
    signalsSettings = signalsSettings.settings;
    signalsSaveableSettings = signalsSaveableSettings.settings;
    if (signalsSaveableSettings.selectedFilters !== undefined) {
      signalsSettings.defaultFilters = signalsSaveableSettings.selectedFilters;
    }
    if (
      signalsSettings.scaleX !== undefined &&
      signalsSaveableSettings.scaleX !== undefined &&
      signalsSaveableSettings.scaleX.defaultIndex !== undefined
    ) {
      signalsSettings.scaleX.defaultIndex = signalsSaveableSettings.scaleX.defaultIndex;
    }
    if (
      signalsSettings.scaleY !== undefined &&
      signalsSaveableSettings.scaleY !== undefined &&
      signalsSaveableSettings.scaleY.defaultIndex !== undefined
    ) {
      signalsSettings.scaleY.defaultIndex = signalsSaveableSettings.scaleY.defaultIndex;
    }
  }
}
